import React from 'react'
import { Box, Typography } from '@mui/material'
import { parseDescriptionBlocks } from '@/utils/propertyDescription'

/**
 * Renders plain-text property descriptions with paragraphs and bullet lists.
 */
function FormattedDescription({
  text,
  align = 'left',
  emptyLabel = null,
  sx = {},
  typographyProps = {},
}) {
  const blocks = parseDescriptionBlocks(text)

  if (blocks.length === 0) {
    if (!emptyLabel) return null
    return (
      <Typography align={align} color="text.secondary" {...typographyProps}>
        {emptyLabel}
      </Typography>
    )
  }

  return (
    <Box
      sx={{
        textAlign: align,
        wordBreak: 'break-word',
        lineHeight: 1.6,
        '& p': { m: 0, mb: 1 },
        '& p:last-child': { mb: 0 },
        '& ul': {
          m: 0,
          mb: 1,
          pl: 2.5,
        },
        '& ul:last-child': { mb: 0 },
        '& li': { mb: 0.5 },
        ...sx,
      }}
    >
      {blocks.map((block, index) => {
        if (block.type === 'list') {
          return (
            <Box component="ul" key={`list-${index}`}>
              {block.items.map((item, itemIndex) => (
                <Typography
                  component="li"
                  key={`item-${index}-${itemIndex}`}
                  {...typographyProps}
                >
                  {item}
                </Typography>
              ))}
            </Box>
          )
        }

        return (
          <Typography
            component="p"
            key={`p-${index}`}
            sx={{ whiteSpace: 'pre-wrap' }}
            {...typographyProps}
          >
            {block.text}
          </Typography>
        )
      })}
    </Box>
  )
}

export default FormattedDescription
